export const STEP_PERSONAL_INFORMATION_USER_INFORMATION: number = 1;
export const STEP_PERSONAL_INFORMATION_ADDRESS_INFORMATION: number = 2;
export const STEP_TERMS_OF_USE: number = 3;
export const STEP_TWO_FACTOR_AUTHENTICATION: number = 4;
export const STEP_NOTIFICATION_PREFERENCE: number = 5;
